import React from 'react';

const PhoneNumber = ({brandingInfo}) => {

    const phoneNumber = brandingInfo?.NoClinicsMessageNumber?? "";

    return <span>{phoneNumber}</span>;
}

export default PhoneNumber